<template>
  <v-container fluid grid-list-lg class="rohy">
    <v-card class="e4">
      <v-img
        src="https://beta.elisabethgarden.sjbdigital.dev/wp-content/plugins/sjb-calcul/pre-rodinu.jpg"
        max-height="150"
        class="grey darken-4"
      ></v-img>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout
            row
            wrap
            d-flex
            align-baseline
            justify-center
            flex-xl-row
            flex-lg-row
            flex-md-row
            flex-sm-row
            flex-xs-row
          >
            <v-flex>
              <v-slider
                xl3
                lg9
                md12
                xs12
                class="mt-15"
                v-model="suma"
                :max="sumaMax"
                label=" Výška hypotéky"
                thumb-label="always"
                track-color="grey-300"
                track-fill-color="#fbb03b"
                :thumb-size="58"
                thumb-color="#fbb03b"
              ></v-slider>
            </v-flex>

            <v-flex xl3 lg3 md12 xs12>
              <v-text-field
                v-model="suma"
                class="mt-0 mb-10 text-position"
                type="string"
                suffix=",- €"
                solo
              ></v-text-field>
            </v-flex>

            <v-flex xl9 lg9 md12 xs12>
              <v-slider
                v-model="roky"
                :max="rokyMax"
                label="Doba splácania"
                thumb-label="always"
                track-color="grey-300"
                track-fill-color="#fbb03b"
                :thumb-size="38"
                thumb-color="#fbb03b"
              ></v-slider>
            </v-flex>

            <v-flex xl3 lg3 md12 xs12>
              <v-text-field
                v-model="roky"
                class="mt-0 mb-10"
                type="string"
                suffix=" rokov"
                solo
              ></v-text-field>
            </v-flex>

            <v-flex xl9 lg9 md12 xs12>
              <v-slider
                v-model="urok"
                :max="urokMax"
                label="Ročný úrok"
                thumb-label="always"
                track-color="grey-300"
                track-fill-color="#fbb03b"
                :thumb-size="32"
                thumb-color="#fbb03b"
                step="0.01"
              ></v-slider>
            </v-flex>

            <v-flex xl3 lg3 md12 xs12>
              <v-text-field
                v-model="urok"
                class="mt-0 mb-10"
                type="string"
                suffix=" %"
                solo
              ></v-text-field>
            </v-flex>

            <v-flex xl9 lg9 md12 xs12>
              <v-slider
                v-model="aaa"
                :max="3000"
                label="Mesačná splátka od"
                thumb-label="always"
                track-color="grey-300"
                track-fill-color="green"
                :thumb-size="44"
                thumb-color="green"
                readonly="true"
              ></v-slider>
              
            </v-flex>

            <v-flex xl3 lg3 md12 xs12 >
              <v-text-field
                v-model="aaa"
                class="mt-0 text-font"
                suffix=",- €"
                solo
              ></v-text-field>

            </v-flex>
              <div style="font-size: 0.9rem;color:rgb(251, 176, 59);text-align:center;background-color: antiquewhite;padding: 1.2rem;">
                <span style="color:green"><b>ZHRNUTIE:</b></span>  ❤  
                <span style="color:grey">Mesačná platba: </span><span style="color:green">{{aaa}},- €</span>  ❤  
                <span style="color:grey">Počet platieb: </span><span style="color:green">{{12*roky}}</span>  ❤  
                <span style="color:grey">Ročná úroková sadzba: </span><span style="color:green">{{urok}} %</span>  ❤  
                <span style="color:grey">Celková suma na úhradu: </span><span style="color:green">{{12*roky*aaa}},- €</span>  ❤  
                <span style="color:grey">Suma preplatenia: </span><span style="color:green">{{12*roky*aaa-suma}},- €</span>  ❤
              </div>
          </v-layout>
          
        </v-container>
      </v-card-text>
      
      <div style="text-align: right;"><a style="font-size: 0.7rem;color: rgb(197 197 197);margin-right: 24px;text-decoration: none;" href="www.sjb.sk" target="_blank">© 2021 <b>SJB, s.r.o.</b></a>
      
      </div>
    </v-card>
    
  </v-container>
</template>

<script>
import axios from "axios"

export default {
  name: "HelloWorld",

  data() {
    
    return {
      
      sumaMax:300000,
      suma: 200000,
      rokyMax: 40,
      roky: 35,
      urok: 0.4,
      urokMax: 3,
      splatka: [],
    }
  },

    mounted: function() {

        var linkTags = (document.querySelector("link[rel=alternate]").href).replace("/wp/v2/", "/acf/v3/");
        console.log(linkTags);

      axios.get(linkTags + "/kalkulacka_cena_aktualna")
        .then(response => {
            this.suma = response.data.kalkulacka_cena_aktualna
        })
       .catch(function (error) {
             console.log(error);
        });

        axios.get(linkTags + "/kalkulacka_cena_maximalna")
        .then(response => {
            this.sumaMax = response.data.kalkulacka_cena_maximalna
        })
       .catch(function (error) {
             console.log(error);
        });


              axios.get(linkTags + "/kalkulacka_roky_aktualne")
        .then(response => {
            this.roky = response.data.kalkulacka_roky_aktualne
        })
       .catch(function (error) {
             console.log(error);
        });

        axios.get(linkTags + "/kalkulacka_roky_maximalne")
        .then(response => {
            this.rokyMax = response.data.kalkulacka_roky_maximalne
        })
       .catch(function (error) {
             console.log(error);
        });

        axios.get(linkTags + "/kalkulacka_urokova_sadzba")
        .then(response => {
            this.urok = response.data.kalkulacka_urokova_sadzba
        })
       .catch(function (error) {
             console.log(error);
        });

  },
  method: {


  },
  computed: {

      cenacislo: function() {
      return (parseInt(((this.datas).replace(/ /g,'')).replace(/,/g,'.')));
        },

      aaa: function() {

      return (
        Number(((this.suma * (this.roky + 1)) / 2) * (this.urok/100)) / this.roky / 12 +
        Number(this.suma / this.roky / 12)
      ).toFixed(0);


    }
    
  }
};

</script>

<style lang="scss" scoped>
.text-font {
  font-size: 22px;
  font-weight: 800;
  color: black;
}
.text-position {
  text-align: right !important;
}
.e4 {
  width: 100%;
  margin: auto;
}
.container {
  padding: 0px;
}
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  text-align: right !important;
}
</style>
